import { render } from "./all-notifications.vue?vue&type=template&id=55473d17"
import script from "./all-notifications.vue?vue&type=script&lang=js"
export * from "./all-notifications.vue?vue&type=script&lang=js"

import "./all-notifications.vue?vue&type=style&index=0&id=55473d17&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__